import React from 'react'
import { PlaceInterface } from '../../../../../common/types/interfaces'
import { ListItem } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: PlaceInterface) => void
  startDuplicate: (el: PlaceInterface) => void
  showDetails: (el: PlaceInterface) => void
  list: PlaceInterface[]
  loading?: boolean
}

export const List = ({ startEdit, startDuplicate, list, showDetails, loading }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.message}>Нет мест</div>
      ) : (
        list.map((el) => (
          <ListItem
            el={el}
            startEdit={startEdit}
            startDuplicate={startDuplicate}
            key={el.id}
            showDetails={showDetails}
          />
        ))
      )}
    </div>
  )
}
